/**
 * ProductBulkActionBar - Sticky Toolbar für Massenaktionen auf Produkten
 *
 * Plan 012: Merge Products + Channel Readiness
 * Aktionen: Batch Generate | Analysieren | Packshot | Ausblenden | [Einblenden] | Schließen
 */

import { Check, X, Lightbulb, Layers, EyeOff, Eye } from 'lucide-react'
import { Button } from '@/components/v2/ui'

interface ProductBulkActionBarProps {
  count: number
  showHidden?: boolean
  isBulkPending?: boolean
  onBatch?: () => void
  onAnalyze?: () => void
  onAssignAll?: () => void
  onHide?: () => void
  onShow?: () => void
  onClear: () => void
}

export function ProductBulkActionBar({
  count, showHidden, isBulkPending,
  onBatch, onAnalyze, onAssignAll, onHide, onShow, onClear,
}: ProductBulkActionBarProps) {
  return (
    <div
      className="products-bulk-action-bar fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex justify-center"
      role="toolbar"
      aria-label="Massenaktionen"
    >
      <div className="flex items-center gap-2 bg-neutral-900 dark:bg-neutral-800 border border-neutral-700 rounded-full px-5 py-2.5 shadow-2xl">
        <span className="text-white text-sm font-medium mr-1" aria-live="polite" aria-atomic="true">
          {count} ausgewählt
        </span>
        {onBatch && (
          <Button variant="secondary" size="sm" onClick={onBatch} className="bg-orange-500 hover:bg-orange-600 text-white border-0">
            <Layers className="w-3 h-3 mr-1" aria-hidden="true" />Batch generieren
          </Button>
        )}
        {onAnalyze && (
          <Button variant="secondary" size="sm" onClick={onAnalyze}>
            <Lightbulb className="w-3 h-3 mr-1" aria-hidden="true" />Analysieren
          </Button>
        )}
        {onAssignAll && (
          <Button variant="primary" size="sm" onClick={onAssignAll}>
            <Check className="w-3 h-3 mr-1" />Packshot setzen
          </Button>
        )}
        {onHide && (
          <Button variant="secondary" size="sm" onClick={onHide} disabled={isBulkPending}
            className="bg-neutral-700 hover:bg-neutral-600 text-white border-0">
            <EyeOff className="w-3 h-3 mr-1" aria-hidden="true" />Ausblenden
          </Button>
        )}
        {showHidden && onShow && (
          <Button variant="secondary" size="sm" onClick={onShow} disabled={isBulkPending}
            className="bg-emerald-600 hover:bg-emerald-500 text-white border-0">
            <Eye className="w-3 h-3 mr-1" aria-hidden="true" />Einblenden
          </Button>
        )}
        <button
          onClick={onClear}
          aria-label="Auswahl aufheben"
          className="text-neutral-400 hover:text-white transition-colors ml-1"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
